import { BASEURL, checktoken, headers } from "../../utils/helper";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { toastError, toastSuccess } from "./other.slice";
import axios from "axios";

const initialState = {
    users: [],
    error: null,
    sloading: false,
    loading: false,
}

export const AdminEmailList = createAsyncThunk('AdminEmailList', async ({ text, role }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/users/list/${role}?text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminSendMails = createAsyncThunk('AdminSendMails', async ({ data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/users/send-mail`, data,
            { headers: headers() })
            .then((res) => {
                if (res.data.success) {
                    console.log(res.data)
                    dispatch(toastSuccess(res.data.message))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const EmailSlice = createSlice({
    name: 'EmailSlice',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(AdminEmailList.pending, (state, action) => {
            state.loading = true
            state.users = []
            return state
        })
        builder.addCase(AdminEmailList.fulfilled, (state, action) => {
            state.loading = false
            state.users = action.payload.data
            return state
        })
        builder.addCase(AdminEmailList.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = 'Error occured'
        })
        builder.addCase(AdminSendMails.pending, (state, action) => {
            state.sloading = true
            return state
        })
        builder.addCase(AdminSendMails.fulfilled, (state, action) => {
            state.sloading = false
            return state
        })
        builder.addCase(AdminSendMails.rejected, (state, action) => {
            state.sloading = false
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default EmailSlice.reducer